<div class="pageHeader" role="heading">

  <!-- Left -->
  <div>
    <p [ngStyle]="{'font-size': leftStringSize,'color': leftStringColor}" *ngFor="let string of leftStrings">
      {{string}}
    </p>
    <ng-content></ng-content>
  </div>

  <!-- Right -->
  <div style="white-space: nowrap">
    <h3 class="sis-app-header-label" style="text-align:right;" translate>{{getPageTitle()}}</h3>
    <div *ngIf="!classroomPage">
      <div style="margin-top: 5px; text-align: right;" translate *ngIf="defaultYear.Description  == '' && (userType != '1' || defaultYear.Status == 1)">
        Academic Year - {{ defaultYear.Description }}
      </div>
      <div style="margin-top: 5px; text-align: right;" *ngIf="defaultYear.Description =='' && userType == '1' && defaultYear.Status != 1">
        <span class="paddedText" [ngStyle]="{'background-color':defaultYear.Status == 0 ? '#ff4081' : '#00e676'}" translate>
          Academic Year - {{ defaultYear.Description }}
        </span>
      </div>
      <div style="margin-top: 5px; text-align: right;" translate *ngIf="defaultYear.Description  != ''">
        Academic Year - {{ defaultYear.Description  }}
      </div>
    </div>
    <div *ngIf="(classroomPage && screenWidth < 1024) || forceYearDisplay" style="white-space:nowrap;">
      <span class="paddedText" *ngIf="defaultYear.Status == 1">
        {{defaultYear.SchoolName}} - {{defaultYear.Description}}
      </span>
      <span class="paddedText" *ngIf="defaultYear.Status != 1" [ngStyle]="{'background-color':defaultYear.Status == 0 ? '#ff4081' : '#00e676'}">
        {{defaultYear.SchoolName}} - {{defaultYear.Description}}
      </span>
    </div>
  </div>
</div>
